module.exports = __webpack_public_path__ + "media/tema_1_warning1_c_CF1.52b42ebf.wav";